'use strict';

import { logger } from '@/logging';
import Vue from 'vue';
import Router from 'vue-router';

import App from './App.vue';
import Home from './views/Home.vue';
import Action from './views/Action.vue';
import Comments from './views/Comments.vue';
import Feedbacks from './views/Feedbacks.vue';
import Feedback from './views/Feedback.vue';
import ErrorPage from './views/ErrorPage.vue';

import { FilterType } from './store/constants';

Vue.use(Router);

const router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
		path: '',
		component: App,
		redirect: FilterType.all,
		children: [
			{
				path: ':filter',
				name: 'action-list',
				component: Home,
			},
			{
				path: ':filter/:id',
				name: 'action-details',
				component: Action,
				props: true,
			},
			{
				path: ':filter/:id/comments',
				name: 'action-comment-list',
				component: Comments,
				props: true,
			},
			{
				path: ':filter/:id/feedbacks',
				name: 'action-feedback-list',
				component: Feedbacks,
				props: true,
			},
			{
				path: ':filter/:id/feedbacks/:fdbk',
				name: 'action-feedback',
				component: Feedback,
				props: true,
			},
			{
				path: 'error',
				name: 'error',
				component: ErrorPage,
			},

			// {
			// 	path: '/:id',
			// 	name: 'details',
			// 	component: Details,
			// 	props: true,
			// 	// route level code-splitting
			// 	// this generates a separate chunk (about.[hash].js) for this route
			// 	// which is lazy-loaded when the route is visited.
			// 	//   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
			// }
		],
	}],
});

router.beforeEach((to, from, next) => {
	logger.get('router').debug('navigating from', from, 'to', to);

	try {
		coerceNumberParam(to.params, 'id');
		coerceNumberParam(to.params, 'fdbk');
		next();
	}
	catch(err) {
		logger.get('router').warn('navigating to error page', err.message);
		next({ name: 'error' });
	}
});

export default router;



const coerceNumberParam = (params, paramName) => {
	const value = params[paramName];
	if (value == null || typeof value === 'number') { return }

	const valueAsNumber = +value;
	if (isNaN(valueAsNumber)) { throw new Error(`invalid route param ${paramName}: expected Number, got "${value}"`) }
	params[paramName] = valueAsNumber;
};